import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CustomersRoutingModule } from './customers-routing.module';

@NgModule({
    declarations: [],
    imports: [CommonModule, CustomersRoutingModule],
})
export class CustomersModule {}
